import React from 'react'
import { t } from 'ttag'

import { Modal } from 'components/shared/Modal/Modal'
import { NoSearchResults } from 'components/shared/NoSearchResults/NoSearchResults'
import { TemplateDetails } from './common/TemplateDetails/TemplateDetails'
import { TemplateSearch } from './common/TemplateSearch/TemplateSearch'

import { useLanguage } from 'hooks'
import { useInternalState } from './hooks'

import styles from './PositionTemplateModal.module.scss'

export const PositionTemplateModal = ({
  activeTemplate,
  onBack,
  onCancel,
  onClose,
  onConfirm,
  setActiveTemplate,
  isOpen,
}) => {
  const language = useLanguage()

  const {
    lastElementRef,
    search: { control },
    templates,
    handleActiveTemplate,
    handleBack,
    handleCancel,
    handleClose,
    handleConfirm,
    isPending,
  } = useInternalState(
    { activeTemplate, isOpen },
    { onBack, onCancel, onClose, onConfirm, setActiveTemplate },
  )

  return (
    <Modal
      backLabel={t`Back`}
      cancelLabel={t`Cancel`}
      confirmLabel={t`Next`}
      className={styles.modal}
      title={t`Choose template`}
      onBack={handleBack}
      onCancel={handleCancel}
      onClose={handleClose}
      onConfirm={handleConfirm}
      {...{ isOpen }}
    >
      <Modal.Header />
      <Modal.Content className={styles.content}>
        <TemplateSearch
          ref={lastElementRef}
          {...{
            activeTemplate,
            control,
            templates,
            handleActiveTemplate,
            isPending,
          }}
        />
        {activeTemplate ? (
          <TemplateDetails {...{ activeTemplate, language }} />
        ) : (
          <NoSearchResults />
        )}
      </Modal.Content>
      <Modal.Footer />
    </Modal>
  )
}
